import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from './firebaseClient';

function Login() {
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const girisYap = async () => {
    setHata('');
    setYukleniyor(true);
    try {
      await signInWithEmailAndPassword(auth, email, sifre);
    } catch (err) {
  console.log(err.code, err.message);
  setHata('Hata: ' + err.code);
}
    setYukleniyor(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm p-8 w-full max-w-sm">
        <h1 className="text-2xl font-bold text-gray-800 mb-2 text-center">QR Menü</h1>
        <p className="text-gray-500 text-sm text-center mb-8">Hesabınıza giriş yapın</p>

        <div className="mb-4">
          <label className="text-sm font-medium text-gray-700 mb-1 block">Email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:border-orange-400"
            placeholder="ornek@email.com"
          />
        </div>

        <div className="mb-6">
          <label className="text-sm font-medium text-gray-700 mb-1 block">Şifre</label>
          <input
            type="password"
            value={sifre}
            onChange={e => setSifre(e.target.value)}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:border-orange-400"
            placeholder="••••••••"
            onKeyDown={e => e.key === 'Enter' && girisYap()}
          />
        </div>

        {hata && <p className="text-red-500 text-sm mb-4 text-center">{hata}</p>}

        <button
          onClick={girisYap}
          disabled={yukleniyor}
          className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold hover:bg-orange-600 disabled:opacity-50">
          {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
        </button>
      </div>
    </div>
  );
}

export default Login;